import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex, Text, Icon } from 'react-orange-ui';
import device from '../../../helpers/breakpoints';
import WordingService from '../../../services/WordingService';

const Container = styled.div`
  position: relative;
  margin: 1rem 0;
`;

const Banner = styled(Flex)`
  background: ${props => props.background};
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
  
  @media ${device.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Actions = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const Details = styled.div`
  display: ${props => props.collapse ? 'none' : 'flex'};
  flex-direction: column;
  border: 3px solid ${props => props.borderColor} ;
  width: 100%;
  padding: 1rem;
`;

const ErrorLabel = styled.p`
  color: ${props => props.color};
  font-weight: bold;
  font-size: 0.725rem;
  text-transform: uppercase;
  margin: 0;
`;

const BannerDetail = ({ label, content, raw }) => {
  let el;
  if (raw) {
    el = (
      <pre>
        {content}
      </pre>
    );
  } else {
    el = (
      <code>
        {content}
      </code>
    );
  }

  return (
    <div style={{ margin: 5 }}>
      <Text size="s">
        {label}
      </Text>
      {el}
    </div>
  );
};

const BannerType = ({ icon, title, color }) => (
  <Flex alignItems="center" style={{ marginRight: 10 }}>
    <Icon icon={icon} height={24} width={24} color={color} style={{ marginRight: 5 }} />
    <ErrorLabel color={color}>
      {WordingService.getWording('title', title)}
    </ErrorLabel>
  </Flex>
);

BannerType.propTypes = {
  /** String icon name */
  icon: PropTypes.oneOf(['warning', 'errorSevere', 'info']).isRequired,
  /** String icon color */
  color: PropTypes.string.isRequired,
  /** String label title */
  title: PropTypes.string.isRequired,
};

BannerDetail.defaultProps = {
  label: '',
  content: '',
  raw: false,
};

BannerDetail.propTypes = {
  /** String label detail */
  label: PropTypes.string,
  /** Content detail */
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /** Boolean raw content format */
  raw: PropTypes.bool,
};

export {
  Actions,
  Banner,
  Container,
  Details,
  BannerDetail,
  BannerType,
};
